//Apps
export const AppStoreLink =
  "https://apps.apple.com/app/colla-pet-tracking/id6742459803";
export const PlayStoreLink =
  "https://play.google.com/store/apps/details?id=com.downriver.colla";
//Support
export const SupportLink = "https://support.collatracking.com";
export const ContactLink =
  "https://support.collatracking.com/en/support/tickets/new";
//Shopify
export const ShopLink = "https://collatracking.com";
export const PlansLink = "https://collatracking.com/pages/plans";
export const AboutLink = "https://collatracking.com/pages/about-us";
export const TermsOfServiceLink =
  "https://collatracking.com/pages/terms-conditions";
export const PrivacyPolicyLink =
  "https://collatracking.com/pages/privacy-policy";
//Socials
export const YoutubeLink = "https://www.youtube.com/@collatracking";
export const FacebookLink = "https://www.facebook.com/collatracking";
export const InstagramLink = "https://www.instagram.com/collatracking/";

//Ecom
export const AmazonLink =
  "https://www.amazon.co.uk/s?k=Colla+GPS+Tracker&sprefix=colla+gps+tracker";

//WebApp
export const SignupLink = "https://app.collatracking.com/signup";
